<template lang="pug" src="./edit-dialog.pug"> </template>
<style lang="scss" src="./edit-dialog.scss" scoped> </style>

<script>
import reasonEditor from '@/components/reason-editor';

export default {
    components: {
        'v-reason-editor': reasonEditor
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        editedReason: {
            type: Object,
            default: null
        }
    },
    computed: {
        editDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        isShowEdit() {
            return this.editedReason && this.editedReason.types.length;
        }
    },
    methods: {
        async editReason() {
            if (this.$refs.reasonEditor.$v.$invalid) {
                this.$refs.reasonEditor.$v.$touch();
            } else {
                await this.$store.dispatch('photoReasons/editRequestReason', this.editedReason);
                this.cancelEditReason();
            }
        },

        resetData() {
            this.$refs.reasonEditor.resetData();
        },

        cancelEditReason() {
            this.editDialog = false;
            this.resetData();
        }
    }
};
</script>
